import { useEffect } from 'react';
import styled from 'styled-components';
import { spacing } from 'ui/theme';
import noop from 'utils/noop';
import { MessageMedium } from 'constants/messageMediums';
import { UpdateMediumFieldsType } from 'modules/templateEditor/common';
import { useEditableFieldsContext } from 'modules/templateEditor/context/EditableFieldsContext';
import { useLocaleSwitchLoader } from 'modules/templateEditor/hooks/useLocaleSwitchLoader';
import { SuggestionApplied } from 'modules/ai/nba/components/previewSuggestion/SuggestionApplied';

const SuggestionAppliedContainer = styled.div`
  margin-top: ${spacing.doubleHalf};
`;

export const NBASuggestion = ({
  suggestedContent: suggestedContentFromProps,
  isSettingsView,
}: { suggestedContent: UpdateMediumFieldsType; isSettingsView: boolean }) => {
  const {
    initialTemplate,
    isDirty,
    isEditMode,
    setCurrentMediumFields,
    setSuggestedContent = noop,
    selectedMessageMedium,
    suggestedContent,
  } = useEditableFieldsContext();
  const { isLoading } = useLocaleSwitchLoader();

  const shouldUpdateContent = isSettingsView && isEditMode;

  useEffect(() => {
    setSuggestedContent(suggestedContentFromProps);
  }, []);

  useEffect(() => {
    // Wait for template to fully load before applying new content
    if (initialTemplate && suggestedContent) {
      if (shouldUpdateContent) {
        // set medium fields to suggested content when in "settings" view and "edit" mode
        setCurrentMediumFields(suggestedContent);
      } else {
        // otherwise, reset suggestedContent
        setSuggestedContent();
      }
    }
  }, [initialTemplate, suggestedContent, shouldUpdateContent]);

  if (!suggestedContent) return null;

  return (
    <SuggestionAppliedContainer>
      <SuggestionApplied
        isDirty={isDirty}
        isLoading={isLoading}
        messageMedium={selectedMessageMedium as MessageMedium}
      />
    </SuggestionAppliedContainer>
  );
};
